import Vue from "vue";
import Router from "vue-router";

import loginPage from "@/pages/login/index";

import mainPage from "@/pages/main/index";

import home from "@/pages/home/index";
import chat from "@/pages/chat/index";
import myCenter from "@/pages/myCenter/index";

import unlockPackage from "@/pages/home/unlockPackage";

import cropper from "@/pages/chat/cropper";
import generateStyle from "@/pages/chat/generateStyle";
import generateResult from "@/pages/chat/generateResult";
// import generateResultChat from "@/pages/chat/generateResultChat";


import editUserInfo from "@/pages/myCenter/editUserInfo";
import editUserPwd from "@/pages/myCenter/editUserPwd";
import setUp from "@/pages/myCenter/setUp";


import userAgreement from "@/pages/model/userAgreement";
import question from "@/pages/model/question";
import questionDetail from "@/pages/model/questionDetail";
import feedback from "@/pages/model/feedback";
import notify from "@/pages/model/notify";
import notifyDetail from "@/pages/model/notifyDetail";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "mainPage",
      component: mainPage,
      children: [
        {
          path: "/login",
          name: "loginPage",
          component: loginPage,
          meta: {
            keepAlive: true // 需要缓存false//不需要缓存
          }
        },
        {
          path: "/",
          name: "home",
          component: home
          //   children: [
          //     {
          //       path: '/',
          //       name: 'homeIndex',
          //       component: homeIndex,
          //     },
          //   ]
        },
        {
          path: "/unlockPackage",
          name: "unlockPackage",
          component: unlockPackage
        },
        {
          path: "/chat",
          name: "chat",
          component: chat
        },
        {
          path: "/cropper",
          name: "cropper",
          component: cropper
        },
        {
          path: "/generateStyle",
          name: "generateStyle",
          component: generateStyle
        },
        {
          path: "/generateResult",
          name: "generateResult",
          component: generateResult
        },
        // {
        //   path: "/generateResultChat",
        //   name: "generateResultChat",
        //   component: generateResultChat
        // },
        {
          path: "/myCenter",
          name: "myCenter",
          component: myCenter
          // children: [
          //   {
          //     path: '/userAgreement',
          //     name: 'userAgreement',
          //     component: userAgreement
          //   },
          // ]
        },
        {
          path: "/user",
          name: "editUserInfo",
          component: editUserInfo
        },
        {
          path: "/password",
          name: "editUserPwd",
          component: editUserPwd
        },
        {
          path: "/set",
          name: "setUp",
          component: setUp
        },

        {
          path: "/question",
          name: "question",
          component: question
        },
        {
          path: "/questionDetail",
          name: "questionDetail",
          component: questionDetail
        },
        {
          path: "/feedback",
          name: "feedback",
          component: feedback
        },
        {
          path: "/userAgreement",
          name: "userAgreement",
          component: userAgreement
        },
        {
          path: "/notify",
          name: "notify",
          component: notify
        },
        {
          path: "/notifyDetail",
          name: "notifyDetail",
          component: notifyDetail
        }
      ]
    }
  ]
});

// 不需要路由验证页面
const whiteList = ["/userAgreement"];
router.beforeEach((to, from, next) => {
  // console.log(to);
  let token = localStorage.getItem("token");
  // console.log('token',token);
  if (whiteList.indexOf(to.path) !== -1) {
    next();
    return;
  }
  if (!token) {
    if (to.path !== "/login") {
      return next("/login");
    }
  }
  if (!to.name) {
    return next("/");
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js